import { render, staticRenderFns } from "./UploadBookDialog.vue?vue&type=template&id=0e6ffcae"
import script from "./UploadBookDialog.vue?vue&type=script&lang=js"
export * from "./UploadBookDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports